import BulkEditProgramSchedule from "../../../../modules/academyPrograms/ui/programs/schedule/BulkEditProgramSchedule";
import { WrapperModalUsers } from "./styled";
import { ProgramScheduleType } from "../../../../types/dto/program";

export const ModalBulkEditProgramsSchedule = ({
  openModal,
  setOpenModal,
  programSchedules,
  onSuccess,
}: {
  openModal: boolean;
  setOpenModal: (value: boolean) => void;
  programSchedules: ProgramScheduleType[];
  onSuccess?: () => void;
}) => {
  return (
    <WrapperModalUsers
      title="Actualizar montos de varios meses"
      open={openModal}
      width={"360px"}
      destroyOnClose
      onClose={() => {
        setOpenModal(false);
      }}
    >
      {programSchedules.length > 0 ? (
        <BulkEditProgramSchedule
          programSchedules={programSchedules}
          setOpenModal={setOpenModal}
          onSuccess={onSuccess}
        />
      ) : null}
    </WrapperModalUsers>
  );
};
